/**
 * @param marker {PropertyMarker}
 * @returns {string}
 */
export function propertyMarkerTemplateCard(marker) {
    return marker.htmlElem !== "" ? marker.htmlElem : 'No information found';
}
